module.exports = __webpack_public_path__ + "media/agent_4_buruburu.852fe92c.mp3";